import React, {useCallback} from 'react';
import {motion} from 'framer-motion';
import {isMobile} from 'react-device-detect';

const Paginator = ({
  className,
  current,
  isAdvance,
  onSubmit,
  onSubmitSegurado,
  onSubmitQuote,
  extraData,
  success,
  data,
  checkAdvance,
  changeButtonStatus,
  onValorBikeError,
  goTo,
  regress,
  children,
  onAdvance,
  onRemoveEquipment,
  onSetEquipmentToUpdate,
  onSetBikeId,
  onSetTotalBike,
  isEdit,
  setIsEdit,
  loading,
  uuid_segurado,
  cnpj_corretor,
  sucessFoto,
  modalAtual,
  canAdvance,
  capaParceiro,
  corPrimaria,
  gerouCotacao,
}) => {
  const getAnimatedValue = useCallback(() => {
    return {x: '-' + current * 100 + '%'};
  }, [current]);

  return (
    <div className={'c_paginator wrapper ' + className}>
      <motion.div initial={false} className="wrapper-items" animate={getAnimatedValue()} transition={{duration: 0.35}}>
        {children.map((Item, index) => (
          <div key={'pgn' + index} className={index === 0 ? 'item-um' : isMobile ? 'item_celular' : 'item'} tabIndex={-1}>
            {
              <Item
                position={index}
                current={current}
                goTo={goTo}
                onSubmit={onSubmit}
                onAdvance={onAdvance}
                onSubmitSegurado={onSubmitSegurado}
                onSubmitQuote={onSubmitQuote}
                regress={regress}
                onValorBikeError={onValorBikeError}
                extraData={extraData}
                success={success}
                prevData={data}
                isAdvance={isAdvance}
                checkAdvance={checkAdvance}
                changeButtonStatus={changeButtonStatus}
                onRemoveEquipment={onRemoveEquipment}
                onSetEquipmentToUpdate={onSetEquipmentToUpdate}
                onSetBikeId={onSetBikeId}
                onSetTotalBike={onSetTotalBike}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                loading={loading}
                sucessFoto={sucessFoto}
                capaParceiro={capaParceiro}
                corPrimaria={corPrimaria}
                uuid_segurado={uuid_segurado}
                cnpj_corretor={cnpj_corretor}
                modalAtual={modalAtual}
                canAdvance={canAdvance}
                gerouCotacao={gerouCotacao}
              />
            }
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default Paginator;
